module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/File-ecf854390825e5cc49fa633ae3230858.svg";